import { Suspense, lazy } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import { PageLayout } from '~/components';

const LandingRoute = lazy(() => import('./LandingRoute'));

export const AppRoutes = () => {
    return (
        <Suspense fallback={null}>
            <Routes>
                <Route
                    element={
                        <PageLayout>
                            <Outlet />
                        </PageLayout>
                    }
                >
                    <Route path="/" element={<LandingRoute />} />
                </Route>
            </Routes>
        </Suspense>
    );
};
